export default {
  backend: {
    url: process.env.VUE_APP_CORE_API_URL
  },
  users: {
    url: process.env.VUE_APP_USER_API_URL
  }
}

